// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-message__buttons{display:flex;justify-content:center}", "",{"version":3,"sources":["webpack://./core/app/scripts/directives/dialog-message.scss"],"names":[],"mappings":"AAAA,0BACE,YAAA,CACA,sBAAA","sourcesContent":[".display-message__buttons {\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
